export default {
  metadata: {
    version: '1.0.0',
    id: 'action-button-1.0.0',
    name: 'JDSActionButton'
  },
  hierarchy: {
    container: [
      {
        'inner-container': ['left-icon', 'jds-text', 'right-icon']
      },
      'loader'
    ]
  },
  base: {
    container: {
      'background-color': '{a_0}',
      opacity: '{a_1}',
      'flex-direction': '{a_2}',
      'align-items': '{a_3}',
      'justify-content': '{a_4}',
      'border-radius': '{a_5}'
    },
    'inner-container': {
      opacity: '{a_64}',
      'border-width': '{a_24}',
      'background-color': '{a_6}',
      'flex-direction': '{a_7}',
      'align-items': '{a_8}',
      'justify-content': '{a_9}',
      'border-radius': '{a_10}',
      'padding-top': '{a_11}',
      'padding-right': '{a_12}',
      'padding-bottom': '{a_13}',
      'padding-left': '{a_14}',
      gap: '{a_15}',
      transition: {
        property: ['background-color', 'border-width', 'border-color'],
        duration: '{medium}',
        'timing-function': '{easeJoyfulEntrance}'
      },
      behavior: {
        hover: {
          'background-color': '{a_16}'
        },
        active: {
          'background-color': '{a_17}'
        },
        focus: {
          'border-width': '{a_18}',
          'border-color': '{a_19}'
        }
      }
    },
    loader: {
      hidden: true,
      color: '{a_20}',
      'background-color': '{a_21}',
      'track-color': '{a_22}',
      'border-width': '{a_23}',
      opacity: '{a_25}',
      size: '{a_26}',
      'z-index': 1
    },
    'left-icon': {
      size: '{a_27}',
      color: '{a_28}',
      hidden: false,
      transition: {
        property: ['color'],
        duration: '{medium}',
        'timing-function': '{easeJoyfulEntrance}'
      },
      behavior: {
        hover: {
          color: '{a_29}'
        },
        active: {
          color: '{a_30}'
        }
      }
    },
    'right-icon': {
      size: '{a_31}',
      color: '{a_32}',
      hidden: true,
      transition: {
        property: ['color'],
        duration: '{medium}',
        'timing-function': '{easeJoyfulEntrance}'
      },
      behavior: {
        hover: {
          color: '{a_33}'
        },
        active: {
          color: '{a_34}'
        }
      }
    },
    'jds-text': {
      'font-family': '{text_137}',
      color: '{text_18}',
      'font-size': '{text_136}',
      'line-height': '{text_138}',
      'letter-spacing': '{text_139}',
      'font-weight': '{text_140}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}',
      'max-lines': 2,
      maxLines: 2,
      hidden: false,
      transition: {
        property: ['color'],
        duration: '{medium}',
        'timing-function': '{easeJoyfulEntrance}'
      },
      behavior: {
        hover: {
          color: '{text_12}',
          transition: {
            property: ['color'],
            duration: '{medium}',
            'timing-function': '{easeJoyfulEntrance}'
          }
        },
        active: {
          transition: {
            property: ['color'],
            duration: '{medium}',
            'timing-function': '{easeJoyfulEntrance}'
          }
        }
      }
    }
  },
  variant: {
    size: {
      small: {
        'inner-container': {
          'padding-top': '{a_35}',
          'padding-right': '{a_36}',
          'padding-bottom': '{a_37}',
          'padding-left': '{a_38}',
          gap: '{a_39}'
        },
        'left-icon': {
          size: '{a_40}'
        },
        'right-icon': {
          size: '{a_41}'
        },
        loader: {
          size: '{a_42}'
        }
      },
      large: {
        'inner-container': {
          'padding-top': '{a_43}',
          'padding-left': '{a_44}',
          'padding-bottom': '{a_45}',
          'padding-right': '{a_46}',
          gap: '{a_47}'
        },
        'left-icon': {
          size: '{a_48}'
        },
        'right-icon': {
          size: '{a_49}'
        },
        loader: {
          size: '{a_50}'
        },
        'jds-text': {
          'font-family': '{text_122}',
          'font-size': '{text_121}',
          'line-height': '{text_123}',
          'letter-spacing': '{text_124}',
          'font-weight': '{text_125}'
        }
      },
      'extra-large': {
        'inner-container': {
          'padding-top': '{a_51}',
          'padding-right': '{a_52}',
          'padding-bottom': '{a_53}',
          'padding-left': '{a_54}',
          gap: '{a_55}'
        },
        'left-icon': {
          size: '{a_56}'
        },
        'right-icon': {
          size: '{a_57}'
        },
        loader: {
          size: '{a_58}'
        },
        'jds-text': {
          'font-family': '{text_107}',
          'font-size': '{text_106}',
          'line-height': '{text_108}',
          'letter-spacing': '{text_109}',
          'font-weight': '{text_110}'
        }
      }
    },
    iconPosition: {
      right: {
        'left-icon': {
          hidden: true
        },
        'right-icon': {
          hidden: false
        }
      }
    },
    state: {
      loading: {
        'inner-container': {
          disabled: true,
          opacity: '{a_59}'
        },
        'left-icon': {
          opacity: '{a_60}'
        },
        'right-icon': {
          opacity: '{a_61}'
        },
        loader: {
          hidden: false
        },
        'jds-text': {
          opacity: '{a_62}'
        }
      },
      disabled: {
        'inner-container': {
          opacity: '{a_63}',
          disabled: true
        }
      },
      _hasIcon: {
        false: {
          'left-icon': {
            hidden: true
          },
          'right-icon': {
            hidden: true
          }
        }
      }
    }
  },
  combination: [
    {
      normal: {
        secondary: {
          'inner-container': {
            'background-color': '{a_65}',
            'border-width': '{a_66}',
            'border-color': '{a_67}',
            behavior: {
              hover: {
                'background-color': '{a_68}'
              },
              active: {
                'background-color': '{a_69}'
              },
              focus: {
                'border-width': '{a_70}',
                'border-color': '{a_71}'
              }
            }
          },
          'left-icon': {
            color: '{a_72}',
            behavior: {
              hover: {
                color: '{a_73}'
              },
              active: {
                color: '{a_74}'
              }
            }
          },
          'right-icon': {
            color: '{a_75}',
            behavior: {
              hover: {
                color: '{a_76}'
              },
              active: {
                color: '{a_77}'
              }
            }
          },
          'jds-text': {
            color: '{text_13}',
            behavior: {
              hover: {},
              active: {
                color: '{text_12}'
              }
            }
          }
        },
        tertiary: {
          'inner-container': {
            'background-color': '{a_78}',
            behavior: {
              hover: {
                'background-color': '{a_79}'
              },
              active: {
                'background-color': '{a_80}'
              },
              focus: {
                'border-width': '{a_81}',
                'border-radius': '{a_82}',
                'border-color': '{a_83}'
              }
            }
          },
          'left-icon': {
            color: '{a_84}',
            behavior: {
              hover: {
                color: '{a_85}'
              },
              active: {
                color: '{a_86}'
              }
            }
          },
          'right-icon': {
            color: '{a_87}',
            behavior: {
              hover: {
                color: '{a_88}'
              },
              active: {
                color: '{a_89}'
              }
            }
          },
          'jds-text': {
            color: '{text_13}',
            behavior: {
              hover: {
                color: '{text_14}'
              },
              active: {
                color: '{text_12}'
              }
            }
          }
        }
      },
      positive: {
        primary: {
          'inner-container': {
            'background-color': '{a_90}',
            behavior: {
              hover: {
                'background-color': '{a_91}'
              },
              active: {
                'background-color': '{a_92}'
              },
              focus: {
                'border-color': '{a_93}'
              }
            }
          },
          'left-icon': {
            color: '{a_94}',
            behavior: {
              hover: {
                color: '{a_95}'
              },
              active: {
                color: '{a_96}'
              }
            }
          },
          'right-icon': {
            color: '{a_97}',
            behavior: {
              hover: {
                color: '{a_98}'
              },
              active: {
                color: '{a_99}'
              }
            }
          },
          'jds-text': {
            color: '{text_62}',
            behavior: {
              hover: {
                color: '{text_59}'
              },
              active: {
                color: '{text_19}'
              }
            }
          }
        },
        secondary: {
          'inner-container': {
            'background-color': '{a_100}',
            'border-width': '{a_101}',
            'border-color': '{a_102}',
            behavior: {
              hover: {
                'background-color': '{a_103}'
              },
              active: {
                'background-color': '{a_104}'
              },
              focus: {
                'border-color': '{a_105}'
              }
            }
          },
          'left-icon': {
            color: '{a_106}',
            behavior: {
              hover: {
                color: '{a_107}'
              },
              active: {
                color: '{a_108}'
              }
            }
          },
          'right-icon': {
            color: '{a_109}',
            behavior: {
              hover: {
                color: '{a_110}'
              },
              active: {
                color: '{a_111}'
              }
            }
          },
          'jds-text': {
            color: '{text_59}',
            behavior: {
              hover: {},
              active: {
                color: '{text_19}'
              }
            }
          }
        },
        tertiary: {
          'inner-container': {
            'background-color': '{a_112}',
            'border-radius': '{a_113}',
            behavior: {
              hover: {
                'background-color': '{a_114}'
              },
              active: {
                'background-color': '{a_115}'
              },
              focus: {
                'border-color': '{a_116}'
              }
            }
          },
          'left-icon': {
            color: '{a_117}',
            behavior: {
              hover: {
                color: '{a_118}'
              },
              active: {
                color: '{a_119}'
              }
            }
          },
          'right-icon': {
            color: '{a_120}',
            behavior: {
              hover: {
                color: '{a_121}'
              },
              active: {
                color: '{a_122}'
              }
            }
          },
          'jds-text': {
            color: '{text_59}',
            behavior: {
              hover: {
                color: '{text_60}'
              },
              active: {
                color: '{text_20}'
              }
            }
          }
        }
      },
      negative: {
        primary: {
          'inner-container': {
            'background-color': '{a_123}',
            behavior: {
              hover: {
                'background-color': '{a_124}'
              },
              active: {
                'background-color': '{a_125}'
              },
              focus: {
                'border-color': '{a_126}'
              }
            }
          },
          'left-icon': {
            color: '{a_127}',
            behavior: {
              hover: {
                color: '{a_128}'
              },
              active: {
                color: '{a_129}'
              }
            }
          },
          'right-icon': {
            color: '{a_130}',
            behavior: {
              hover: {
                color: '{a_131}'
              },
              active: {
                color: '{a_132}'
              }
            }
          },
          'jds-text': {
            color: '{text_62}',
            behavior: {
              hover: {
                color: '{text_53}'
              },
              active: {
                color: '{text_19}'
              }
            }
          }
        },
        secondary: {
          'inner-container': {
            'background-color': '{a_133}',
            'border-width': '{a_134}',
            'border-color': '{a_135}',
            behavior: {
              hover: {
                'background-color': '{a_136}'
              },
              active: {
                'background-color': '{a_137}'
              },
              focus: {
                'border-color': '{a_138}'
              }
            }
          },
          'left-icon': {
            color: '{a_139}',
            behavior: {
              hover: {
                color: '{a_140}'
              },
              active: {
                color: '{a_141}'
              }
            }
          },
          'right-icon': {
            color: '{a_142}',
            behavior: {
              hover: {
                color: '{a_143}'
              },
              active: {
                color: '{a_144}'
              }
            }
          },
          'jds-text': {
            color: '{text_53}',
            behavior: {
              hover: {},
              active: {
                color: '{text_19}'
              }
            }
          }
        },
        tertiary: {
          'inner-container': {
            'background-color': '{a_145}',
            'border-radius': '{a_146}',
            behavior: {
              hover: {
                'background-color': '{a_147}'
              },
              active: {
                'background-color': '{a_148}'
              },
              focus: {
                'border-color': '{a_149}'
              }
            }
          },
          'left-icon': {
            color: '{a_150}',
            behavior: {
              hover: {
                color: '{a_151}'
              },
              active: {
                color: '{a_152}'
              }
            }
          },
          'right-icon': {
            color: '{a_153}',
            behavior: {
              hover: {
                color: '{a_154}'
              },
              active: {
                color: '{a_155}'
              }
            }
          },
          'jds-text': {
            color: '{text_53}',
            behavior: {
              hover: {
                color: '{text_54}'
              },
              active: {
                color: '{text_20}'
              }
            }
          }
        }
      },
      contrast: {
        primary: {
          'inner-container': {
            'background-color': '{a_156}',
            behavior: {
              hover: {
                'background-color': '{a_157}'
              },
              active: {
                'background-color': '{a_158}'
              },
              focus: {
                'border-color': '{a_159}'
              }
            }
          },
          'left-icon': {
            color: '{a_160}',
            behavior: {
              hover: {
                color: '{a_161}'
              },
              active: {
                color: '{a_162}'
              }
            }
          },
          'right-icon': {
            color: '{a_163}',
            behavior: {
              hover: {
                color: '{a_164}'
              },
              active: {
                color: '{a_165}'
              }
            }
          },
          'jds-text': {
            color: '{text_20}',
            behavior: {
              hover: {},
              active: {}
            }
          }
        },
        secondary: {
          'inner-container': {
            'background-color': '{a_166}',
            'border-width': '{a_167}',
            'border-color': '{a_168}',
            behavior: {
              hover: {
                'background-color': '{a_169}'
              },
              active: {
                'background-color': '{a_170}'
              },
              focus: {
                'border-width': '{a_171}',
                'border-color': '{a_172}'
              }
            }
          },
          'left-icon': {
            color: '{a_173}',
            behavior: {
              hover: {
                color: '{a_174}'
              },
              active: {
                color: '{a_175}'
              }
            }
          },
          'right-icon': {
            color: '{a_176}',
            behavior: {
              hover: {
                color: '{a_177}'
              },
              active: {
                color: '{a_178}'
              }
            }
          },
          'jds-text': {
            color: '{text_19}',
            behavior: {
              hover: {
                color: '{text_20}'
              },
              active: {
                color: '{text_20}'
              }
            }
          }
        },
        tertiary: {
          'inner-container': {
            'background-color': '{a_179}',
            'border-radius': '{a_180}',
            behavior: {
              hover: {
                'background-color': '{a_181}'
              },
              active: {
                'background-color': '{a_182}'
              },
              focus: {
                'border-width': '{a_183}',
                'border-color': '{a_184}'
              }
            }
          },
          'left-icon': {
            color: '{a_185}',
            behavior: {
              hover: {
                color: '{a_186}'
              },
              active: {
                color: '{a_187}'
              }
            }
          },
          'right-icon': {
            color: '{a_188}',
            behavior: {
              hover: {
                color: '{a_189}'
              },
              active: {
                color: '{a_190}'
              }
            }
          },
          'jds-text': {
            color: '{text_19}',
            behavior: {
              hover: {
                color: '{text_17}'
              },
              active: {
                color: '{text_16}'
              }
            }
          }
        }
      }
    },
    {
      false: {
        small: {
          'inner-container': {
            'padding-top': 0,
            'padding-right': 0,
            'padding-bottom': 0,
            'padding-left': 0,
            width: 32,
            height: 32
          },
          'left-icon': {
            size: '{a_191}'
          },
          loader: {
            size: '{a_192}'
          },
          'jds-text': {
            hidden: true
          }
        },
        medium: {
          'inner-container': {
            'padding-top': 0,
            'padding-right': 0,
            'padding-bottom': 0,
            'padding-left': 0,
            width: 40,
            height: 40
          },
          'jds-text': {
            hidden: true
          }
        },
        large: {
          'inner-container': {
            'padding-top': 0,
            'padding-right': 0,
            'padding-bottom': 0,
            'padding-left': 0,
            width: 48,
            height: 48
          },
          'left-icon': {
            size: '{a_193}'
          },
          loader: {
            size: '{a_194}'
          },
          'jds-text': {
            hidden: true
          }
        },
        'extra-large': {
          'inner-container': {
            'padding-top': 0,
            'padding-right': 0,
            'padding-bottom': 0,
            'padding-left': 0,
            width: 64,
            height: 64
          },
          'left-icon': {
            size: '{a_195}'
          },
          loader: {
            size: '{a_196}'
          },
          'jds-text': {
            hidden: true
          }
        }
      }
    },
    {
      true: {
        true: {
          container: {
            width: '{a_197}'
          },
          'inner-container': {
            width: '{a_198}'
          }
        }
      }
    }
  ],
  combination_config: [
    ['appearance', 'kind'],
    ['_hasLabel', 'size'],
    ['_hasLabel', 'stretch']
  ],
  api: {
    config: {
      kind: {
        values: ['primary', 'secondary', 'tertiary'],
        doc_description:
          "It can be used to switch between 3 variants of ActionButton which is by default 'primary'."
      },
      size: {
        values: ['medium', 'small', 'large', 'extra-large'],
        doc_description: 'it can be used to control the size of ActionButton.'
      },
      appearance: {
        values: ['normal', 'positive', 'negative', 'contrast'],
        doc_description: 'It can be used to set the appearance of ActionButton.'
      },
      state: {
        values: ['normal', 'disabled', 'loading'],
        doc_description: 'It can be used to change the state of ActionButton.'
      },
      iconPosition: {
        values: ['left', 'right'],
        doc_description: 'It can be used to psoition icon.'
      },
      stretch: {
        values: [false, true],
        doc_description:
          'This can be used to fill the container with ActionButton.'
      },
      _hasLabel: {
        values: [true, false]
      },
      _hasIcon: {
        values: [true, false]
      }
    },
    data: {
      container: {
        type: {
          name: 'type',
          type: 'string',
          platform: 'web'
        }
      },
      'left-icon': {
        value: {
          type: 'icon',
          name: 'icon',
          doc_description: 'It displays icon of ActionButton.'
        }
      },
      'right-icon': {
        value: {
          type: 'icon',
          name: 'icon',
          doc_description: 'It displays icon of ActionButton.'
        }
      },
      'jds-text': {
        value: {
          type: 'string',
          name: 'label',
          doc_description: 'It displays label of ActionButton.'
        }
      }
    },
    events: {
      'inner-container': {
        onClick: 'onClick',
        onFocus: {
          name: 'onFocus',
          platform: 'web'
        }
      }
    },
    a11y: {
      'inner-container': {
        properties: {
          role: {
            value: 'button'
          },
          'aria-label': {
            name: 'ariaLabel',
            prop: 'label'
          },
          'aria-describedby': {
            name: 'ariaDescribedby',
            platform: 'web,ios'
          }
        }
      },
      'left-icon': {
        properties: {
          role: {
            value: 'img'
          },
          'aria-label': {
            name: 'iconAriaLabel',
            function: true
          }
        }
      },
      'right-icon': {
        properties: {
          role: {
            value: 'img'
          },
          'aria-label': {
            name: 'iconAriaLabel',
            function: true
          }
        }
      }
    }
  }
};
